export class Procedure {
    name:string;
    description:string;
    id: number;
    modifiedByUserName: string;
    modifiedDate: Date;    
    mostRecent: boolean;
    errorMessage:string;
}
